<app-uni-page
  [parent]="this"
  pageTitle="Job Order - Pull to Work in Process - Batch Id: {{
    joPullBatchId
  }} - {{ batchStatusLabel }}"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[30, 70]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="my-2 mr-4 flex shrink-0 items-center gap-2.5">
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-refresh"
            (click)="changeBatch()"
          >
            <span>Change Batch</span>
          </button>
          <button
            *ngIf="canMarkComplete"
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-check"
            [disabled]="isBusy()"
            (click)="markBatchComplete()"
          >
            <span>Mark Batch Complete</span>
          </button>
          <button
            *ngIf="canUncomplete"
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-undo"
            [disabled]="isBusy()"
            (click)="uncompleteBatch()"
          >
            <span>Incomplete Batch</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-print"
            [disabled]="!canPrintItemDetailBarcodes()"
            (click)="printItemDetailBarcodes()"
          >
            <span>Print Barcodes</span>
          </button>
          <p-checkbox
            [(ngModel)]="shouldPrintBarcodes"
            (ngModelChange)="updateLocation()"
            name="shouldPrintBarcodes"
            inputId="shouldPrintBarcodes"
            [binary]="true"
          ></p-checkbox>
          <label for="shouldPrintBarcodes" class="text-sm">Automatically Print Barcodes</label>
        </div>
        <app-ag-grid
          [gridOptions]="johGridOptions"
          [rowData]="joHeaders"
          class="flex-1 min-h-0"
        ></app-ag-grid>
        <ng-template #deleteJoHeaderFromBatchCell let-row>
          <button
            pButton type="button" class="p-button-text p-button-sm"
            *ngIf="canDeleteJoHeaderFromBatch(row)"
            (click)="deleteJoHeaderFromBatch(row)"
          >
            Delete
          </button>
        </ng-template>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <app-ag-grid
          [gridOptions]="jodGridOptions"
          [rowData]="joDetails"
        ></app-ag-grid>
        <ng-template #viewDocCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="hasAddonDocs(row)" (click)="viewAddonDocs(row)">
            View Documents
          </button>
        </ng-template>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
